import { render, staticRenderFns } from "./FormRouteLocaleSchoolExcursion.vue?vue&type=template&id=c22d555a&scoped=true&"
import script from "./FormRouteLocaleSchoolExcursion.vue?vue&type=script&lang=js&"
export * from "./FormRouteLocaleSchoolExcursion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22d555a",
  null
  
)

export default component.exports